import React from 'react';
import { SpecialKeys } from '../utils';
import Key from './Key';
import './Keyboard.less';

type KeyboardProps = {
  handleInput: (value: string) => void;
};

const Keyboard = ({ handleInput }: KeyboardProps) => {
  return (
    <div className="keyboardContainer">
      <div className="keyRow">
        {['Q', 'W', 'E', 'R', 'T', 'Y', 'U', 'I', 'O', 'P'].map((key) => (
          <Key
            handleInput={handleInput}
            value={key}
            key={key}
          />
        ))}
      </div>
      <div className="keyRow">
        {['A', 'S', 'D', 'F', 'G', 'H', 'J', 'K', 'L'].map((key) => (
          <Key
            handleInput={handleInput}
            value={key}
            key={key}
          />
        ))}
      </div>
      <div className="keyRow">
        <Key handleInput={handleInput} value={SpecialKeys.Enter}/>
        {['Z', 'X', 'C', 'V', 'B', 'N', 'M'].map((key) => (
          <Key
            handleInput={handleInput}
            value={key}
            key={key}
          />
        ))}
        <Key handleInput={handleInput} value={SpecialKeys.Delete}/>
      </div>
    </div>
  );
};

export default Keyboard;